<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Cadastrar" : "Atualizar" }} Produto</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Product Image -->
        <template v-if="productPictureUrl">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="productPictureUrl" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Carregar Imagem</vs-button>
            <vs-button type="flat" color="#999" @click="productPictureUrl = null">Remover Imagem</vs-button>
          </div>
        </template>

        <div class="upload-img mt-5" v-if="!productPictureUrl">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Carregar Imagem</vs-button>
        </div>

        <vs-divider/>
        <h5 class="mb-4">Informações básicas</h5>

        <!-- CUSTOMER ID -->
        <vs-input label="ID do produto" v-model="customerProductId" class="mt-5 w-full" name="item-id" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-id')">{{ errors.first('item-id') }}</span>

        <!-- NAME -->
        <vs-input label="Nome" v-model="name" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <!-- CATEGORY -->
        <vs-select v-model="toBeProcessed" label="Categoria" class="mt-5 w-full" name="item-category" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in category_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>
        <vs-input label="Tipo" v-model="typeText" class="mt-5 w-full" name="item-type-text"/>
        <!--unit-->
        <vs-select v-model="unit" label="Unidade" class="mt-5 w-full" name="item-category" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in unit_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>

        <!-- PRICE -->
        <vs-input
          icon-pack="feather"
          icon="icon-dollar-sign"
          label="Valor unitário"
          v-model="price"
          class="mt-5 w-full"
          type="number"
          name="item-price" />
        <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span>

        <!-- Valid days -->
        <vs-input label="Validade (dias)" type="number" v-model="validDays" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <vx-input-group class="mt-5">
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span>Descrição</span>
            </div>
          </template>
          <vs-textarea v-model="descriptionText" />
        </vx-input-group>
        
        <vs-divider/>
        <h5 class="mb-4">Cores disponíveis</h5>
        <div>
          <p class="certLabel">Escolha um conjunto de cores (Opcional)</p>
          <ul class="clearfix">
            <li :style="{backgroundColor: customPrimaryColor}"
              :class="{'shadow-outline': customPrimaryColor == primaryColor}"
              class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"
              @click="registerNewColor(customPrimaryColor)"/>
            <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="customPrimaryColor" type="color"/></li>
          </ul>
          <vs-checkbox class="mt-5" v-model="transparent">Transparente</vs-checkbox>

          <p class="certLabel">Cores escolhidas</p>
          <ul class="clearfix">
            <li v-for="color in colorOptions" :key="color" :style="{backgroundColor: color}"
              :class="{'shadow-outline': true}"
              class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" @click="updateColor(color)"/>
          </ul>
        </div>
        
        <vs-divider/>
        <h5 class="mb-4">Cubagem</h5>
        <vs-input type="number" label="Altura (m)" v-model="heightText" class="mt-5 w-full" name="item-weight-text"/>
        <vs-input type="number" label="Largura (m)" v-model="widthText" class="mt-5 w-full" name="item-weight-text"/>
        <vs-input type="number" label="Comprimento (m)" v-model="sizeText" class="mt-5 w-full" name="item-weight-text"/>
        <vs-input label="Espessura (mm)" v-model="thickness" class="mt-5 w-full" name="item-thickness-text" type="number"/>
        <vs-input type="number" label="Peso (Kg)" v-model="weightValue" class="mt-5 w-full" name="item-weight-text"/>

        <vs-divider/>
        <h5 class="mb-4">Economia circular</h5>
        <vs-input label="Composição (% de material reciclável)" v-model="compositionValue" class="mt-5 w-full" name="item-composition-text" type="number"/>
        <vs-checkbox class="mt-5" v-model="returnItem">Item retornável</vs-checkbox>
        <vs-input label="Link para instruções de triagem" v-model="linkTri" class="mt-5 w-full" name="item-linktri-text"/>
        <vs-input label="Link para o vídeo da área do QR-CODE" v-model="linkInst" class="mt-5 w-full" name="item-linkinst-text"/>
        <vx-input-group class="mt-5">
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span>Orientação para retorno</span>
            </div>
          </template>
          <vs-textarea v-model="returnInstructionDesc" />
        </vx-input-group>
        
        <vs-divider/>
        <h5 class="mb-4">Certificados</h5>
        <vs-col v-for="(cert, index) in certs" :key="index">
          <vs-checkbox class="mt-5" v-model="Certificates" :vs-value="cert.name">{{ cert.name }}</vs-checkbox>
        </vs-col>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Ok</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    certs: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      transparent: false,
      primaryColor : '#FFFFFF',
      customPrimaryColor : '#FFFFFF',
      id: null,
      price: 0,
      returnItem: false,
      name: '',
      unit: null,
      validDays: 0,
      toBeProcessed: null,
      packing: null,
      residue: false,
      productPictureUrl: null,
      customerProductId: null,
      Colors: [],
      typeText: null,
      heightText: null,
      widthText: null,
      sizeText: null,
      volumeText: null,
      compositionValue: null,
      thickness: null,
      weightValue: null,
      descriptionText: null,
      returnInstructionDesc: null,
      linkTri: null,
      linkInst: null,
      colorText: '#000000',
      Certificates: [],
      category_choices: [
        { text:'Embalagem', value:'packing' },
        { text:'Natural', value:'natural' },
        { text:'Processado', value:'processed' },
        { text:'Resíduo', value:'residue' }
      ],
      unit_choices: [
        {text: 'g', value: 'g' },
        {text: 'mg', value: 'mg' },
        {text: 'Kg', value: 'Kg' },
        {text: 'arroba', value: 'arroba' },
        {text: 'ton', value: 'ton' },
        {text: 'caixa', value: 'caixa' },
        {text: 'saca', value: 'saca' },
        {text: 'raza', value: 'raza' },
        {text: 'lata', value: 'lata' },
        {text: 'm3', value: 'm3' },
        {text: 'ml', value: 'ml' },
        {text: 'l', value: 'l' },
        {text: 'unidade', value: 'unidade' }
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    compositionValue (val) { if (val > 100) this.compositionValue = 100 },
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {
          id,
          toBeProcessed,
          productPictureUrl,
          name,
          price,
          customerProductId,
          Colors,
          unit,
          validDays,
          residue,
          packing,
          typeText,
          sizeText,
          widthText,
          heightText,
          volumeText,
          compositionValue,
          thickness,
          weightValue,
          descriptionText,
          returnInstructionDesc,
          linkTri,
          linkInst,
          colorText,
          Certificates,
          returnItem
        } = JSON.parse(JSON.stringify(this.data))
        this.id = id
        this.packing = packing
        this.customerProductId = customerProductId
        this.Colors = Colors
        this.toBeProcessed = toBeProcessed ? (residue ? 'residue' : 'processed') : (packing ? 'packing' : 'natural')
        this.residue = residue
        this.unit = unit
        this.productPictureUrl = productPictureUrl
        this.name = name
        this.price = price
        this.validDays = validDays
        this.typeText = typeText
        this.sizeText = sizeText
        this.widthText = widthText
        this.heightText = heightText
        this.volumeText = volumeText
        this.compositionValue = compositionValue ? compositionValue : null
        this.thickness = thickness ? thickness : null
        this.weightValue = weightValue ? weightValue : null
        this.descriptionText = descriptionText
        this.returnInstructionDesc = returnInstructionDesc
        this.returnItem = returnItem
        this.linkTri = linkTri
        this.linkInst = linkInst
        this.colorText = colorText ? colorText : '#000000'
        this.Certificates = Certificates.map(e => e.name)
        this.initValues()
      }
    }
  },
  computed: {
    colorOptions () { return this.Colors.map(e => e.color) },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) { this.$emit('closeSidebar') }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.toBeProcessed && this.price >= 0 && this.productPictureUrl && this.unit && this.validDays >= 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    updateColor (color) {
      this.colorText = color
    },
    registerNewColor (value) {
      this.primaryColor = value
      if (!this.Colors.find(e => e.color === value && e.transparent === this.transparent)) {
        this.Colors.push({ color: value, transparent: this.transparent })
      }
    },
    initValues () {
      if (this.data.id) return
      this.customerProductId = null
      this.Colors = []
      this.name = ''
      this.toBeProcessed = null
      this.residue = false
      this.packing = false
      this.returnItem = false
      this.price = 0
      this.validDays = 0
      this.unit = null
      this.productPictureUrl = null
      this.typeText = null
      this.sizeText = null
      this.widthText = null
      this.heightText = null
      this.volumeText = null
      this.compositionValue = null
      this.thickness = null
      this.weightValue = null
      this.descriptionText = null
      this.returnInstructionDesc = null
      this.linkTri = null
      this.linkInst = null
      this.colorText = '#000000'
      this.Certificates = []
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            name: this.name,
            customerProductId: this.customerProductId,
            colorList: this.Colors,
            productPictureUrl: this.productPictureUrl,
            toBeProcessed: this.toBeProcessed === 'processed' || this.toBeProcessed === 'residue',
            residue: this.toBeProcessed === 'residue',
            packing: this.toBeProcessed === 'packing',
            price: this.price,
            validDays: this.validDays,
            unit: this.unit,
            typeText: this.typeText,
            sizeText: this.sizeText,
            heightText: this.heightText,
            widthText: this.widthText,
            volumeText: this.volumeText,
            compositionValue: this.compositionValue ? this.compositionValue : null,
            thickness: this.thickness ? this.thickness : null,
            weightValue: this.weightValue ? this.weightValue : null,
            descriptionText: this.descriptionText,
            returnInstructionDesc: this.returnInstructionDesc,
            linkTri: this.linkTri,
            linkInst: this.linkInst,
            returnItem: this.returnItem,
            colorText: this.colorText,
            Certificates: this.certs.filter(e => this.Certificates.includes(e.name))
          }
          if (this.data.id !== null && this.data.id >= 0) {
            this.$emit('updateProduct', { body: obj, id: this.id })
            this.id = null
          } else {
            delete obj.id
            this.id = null
            this.$emit('createProduct', obj)
          }
          this.initValues()
          this.$emit('closeSidebar')
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.readAsDataURL(input.target.files[0])
        reader.onload = () => { this.productPictureUrl = reader.result }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}

.certLabel {
  font-size: 12px;
  margin-left: 5px;
  margin-top: 10px;
}
</style>
